import styled from 'styled-components';
import {
  MOBILE_BREAKPOINT,
  SELECTORS,
  TABLET_BREAKPOINT,
  UBISOFT_BOLD_FONT,
  UBUNTU_FONT
} from '../../../../constants';
import CONFIG from '../../../../config';

interface IFaqContainerProps {
  beforeContent: string;
}

export const GreyButtonContainer = styled.div`
  ${SELECTORS} & {
    background: transparent;
    border: 2px solid white;
    color: white;
    width: fit-content;
    position: relative;
    padding: 15px 30px;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    border-radius: 27px;
    transition: all 0.12s ease-in-out;
    overflow: hidden;
    cursor: pointer;
    margin: auto 0;
    font-size: 16px;
    &:before {
      content: ${({ beforeContent }: IFaqContainerProps) =>
        `'${beforeContent}'`};
      font-family: ${() =>
        CONFIG.isUPC ? UBUNTU_FONT : UBISOFT_BOLD_FONT} !important;
      font-weight: ${() => (CONFIG.isUPC ? 700 : 0)} !important;
      transition: all 0.12s ease-in-out;
      opacity: 1;
      color: white;
      font-size: 16px;
      position: absolute;
      text-align: center;
      -webkit-transform: translate3d(0, 56px, 0);
      transform: translate3d(0, 56px, 0);
      display: block;
      line-height: normal;
    }

    &:hover {
      &:before {
        transform: translate3d(0, 0, 0);
      }
    }

    @media (max-width: ${TABLET_BREAKPOINT}) {
      ${SELECTORS} & {
        &:before {
          font-size: 16px;
        }
      }
    }

    @media (max-width: ${MOBILE_BREAKPOINT}) {
      ${SELECTORS} & {
        width: 100%;
        margin: auto;
        text-align: center;
      }
    }
  }

  @media (max-width: 600px) {
    ${SELECTORS} & {
      width: 90%;
      text-align: center;
    }
  }
`;

export const GreyButtonText = styled.span`
  ${SELECTORS} & {
    transition: all 0.12s ease-in-out;
    display: block;
    font-size: 16px;
    opacity: 1;
    line-height: normal;
    max-height: 25px;
    color: white;

    font-family: ${() =>
      CONFIG.isUPC ? UBUNTU_FONT : UBISOFT_BOLD_FONT} !important;
    font-weight: ${() => (CONFIG.isUPC ? 700 : 0)} !important;
  }

  @media (max-width: ${TABLET_BREAKPOINT}) {
    ${SELECTORS} & {
      font-size: 16px;
    }
  }

  ${GreyButtonContainer}:hover & {
    transform: translate3d(0, -56px, 0);
  }
`;
